import { toast } from "react-toastify";

const toastDark = (text) => toast.dark(text);
const toastInfo = (text) => toast.info(text);
const toastSuccess = (text) => toast.success(text);
const toastWarn = (text) => toast.warn(text);
const toastError = (text) => toast.error(text);
export { toastInfo, toastSuccess, toastError,toastDark,toastWarn };
